/** Firmendaten – werden auf Kontaktseite, im Header und im Footer verwendet */
export const SETTINGS_KEY = 'settings';

export const SETTINGS_DEFAULTS = {
  company_name: 'TOP Buchhaltungsservice UG',
  address: 'Stuttgartstraße 15-17, 44143 Dortmund',
  maps_url: 'https://maps.google.com/?q=Stuttgartstraße+15-17,+44143+Dortmund',
  phone: '+49 1575 5659651',
  phone_landline: '+49 231 53479212',
  whatsapp: '+49 1575 5659651',
  email: 'info@top-bhs.de',
  /** Empfänger für Benachrichtigungen über neue Kontaktanfragen (leer = E-Mail oben) */
  notification_email: '',
  logo: '/images/logo.webp',
  social_links: [
    { name: 'LinkedIn', url: '' },
    { name: 'Instagram', url: '' },
    { name: 'X', url: '' },
  ],
};

export type Settings = typeof SETTINGS_DEFAULTS;

export const phoneHref = (phone: string): string => `tel:${phone.replace(/[^+\d]/g, '')}`;
export const whatsappHref = (phone: string): string => `https://wa.me/${phone.replace(/\D/g, '')}`;
